import { validateEmail, validatePhoneNumber } from 'common/utils/validators';

// Empty fields stay valid per Figma 6326-292804: validation only fires when
// the user has actually entered something. RHF runs `validate` whenever the
// field's value changes — returning `true` on empty short-circuits the
// regex check and keeps the field error-free until the user types.

export const phoneNumberValidation = (errorMsg: string) => ({
  validate: {
    validPhoneNumber: (value: string) => {
      if (value.length === 0) return true;
      return validatePhoneNumber(value) || errorMsg;
    },
  },
});

export const emailValidation = (errorMsg: string) => ({
  validate: {
    validEmail: (value: string) => {
      if (value.length === 0) return true;
      return validateEmail(value) || errorMsg;
    },
  },
});
